var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 42,
    viewBox: "0 0 51 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 22.905C23.5977 18.959 19.4785 16.25 14.6667 16.25C7.66537 16.25 2 21.9154 2 28.9167",
    stroke: "#00A3FA",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.33333C21 11.834 18.1673 14.6667 14.6667 14.6667C11.166 14.6667 8.33333 11.834 8.33333 8.33333C8.33333 4.83268 11.166 2 14.6667 2C18.1673 2 21 4.83268 21 8.33333Z",
    stroke: "#00A3FA",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1667 8.33333C43.1667 11.834 40.334 14.6667 36.8333 14.6667C33.3327 14.6667 30.5 11.834 30.5 8.33333C30.5 4.83268 33.3327 2 36.8333 2C40.334 2 43.1667 4.83268 43.1667 8.33333Z",
    stroke: "#00A3FA",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 27.3333C49.5 34.3346 43.8346 40 36.8333 40C29.832 40 24.1667 34.3346 24.1667 27.3333C24.1667 20.332 29.832 14.6666 36.8333 14.6666C43.8346 14.6666 49.5 20.332 49.5 27.3333Z",
    stroke: "#00A3FA",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8333 19.4166V35.25",
    stroke: "#00A3FA",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9167 27.3334H44.75",
    stroke: "#00A3FA",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamEmptyIcon);
export default __webpack_public_path__ + "static/media/team-empty-icon.37d1981d7ed65e46b5ca98aba6bfe6a1.svg";
export { ForwardRef as ReactComponent };